import { classicFormat } from '@/hooks/format/useFormatNumber';

import type { ChartType } from '@/lib/analytics/charts/type';
import { ORIENTATION_HORIZONTAL } from '@/lib/gridElements/orientation';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { X } from '@/lib/socialProfile';

import { HalfBarChart } from '@/components/composite/Charts/HalfBarChart';

export const postsDistributionConfig: ChartType<typeof HalfBarChart> = {
    tooltip: 'chart.twitter.posts_distribution_tooltip',
    id: 'posts_distribution',
    margin: {
        left: -35
    },
    social: X,
    orientation: ORIENTATION_HORIZONTAL,
    datePickerDoesNotApply: false,
    barSize: 35,
    isStacked: true,
    tickFormatterTranslation: 'chart.time_unit',
    tooltipValueTranslation: 'chart.twitter.posts_distribution_value',
    name: {
        month: 'month',
        week: 'week'
    },
    valueFormat: classicFormat,
    size: SIZE_FULL,
    type: 'chart',
    element: HalfBarChart,
    defaultFilter: 'month',
    color: {},
    valueColors: [
        'aquablue',
        'green',
        'blue',
        'red',
        'yellow',
        'purple',
        'pink',
        'orange',
        'lightaquablue',
        'lightgreen',
        'lightblue',
        'lightred',
        'lightyellow',
        'lightpurple',
        'lightpink',
        'lightorange'
    ],
    filters: {
        month: {
            title: 'chart.twitter.posts_distribution_monthly',
            menu: 'chart.twitter.posts_distribution_filter_monthly'
        },
        week: {
            title: 'chart.twitter.posts_distribution_weekly',
            menu: 'chart.twitter.posts_distribution_filter_weekly'
        }
    }
};
